import { bostaHttp, sllrHttp } from 'http.js';
import { downloadHeader } from 'utils/download';

export const getDraftOrders = (payload) => {
  return sllrHttp.get('/sllrSalesOrders', payload);
};

export const getDraftOrderById = (id) => {
  return sllrHttp.get(`/sllrSalesOrders/${id}/details`);
};

export const getDeleteOrder = (id) => {
  return sllrHttp.get(`/sllrSalesOrders/deleted/${id}`);
};

export const getDeletedOrders = (payload) => {
  return sllrHttp.get('/sllrSalesOrders/deleted', payload);
};

export const editDraftOrder = (id, payload) => {
  return sllrHttp.put(`/sllrSalesOrders/v2/${id}`, payload);
};

export const editConfirmedOrder = (id, payload) => {
  return sllrHttp.put(`/salesOrders/confirmed/${id}`, payload);
};

export const confirmDraftOrder = (id, payload) => {
  return sllrHttp.post(`/sllrSalesOrders/${id}/confirm`, payload);
};

export const deleteDraftOrder = (id, payload) => {
  return sllrHttp.delete(`/sllrSalesOrders/${id}`, payload);
};

export const deleteSelfMangeDraftOrder = (id) => {
  return sllrHttp.delete(`/sllrSalesOrders/confirmed/${id}`);
};

export const deleteSelfMangeBulkOrders = (payload) => {
  return sllrHttp.delete(`/sllrSalesOrders/confirmed/bulk`, payload);
};

export const restoreDeletedOrder = (id) => {
  return sllrHttp.put(`/sllrSalesOrders/restore/${id}`);
};

export const massConfirmDraftOrders = (payload) => {
  return sllrHttp.post('/sllrSalesOrders/bulkConfirm', payload);
};

export const massCancelDraftOrders = (payload) => {
  return sllrHttp.post('/sllrSalesOrders/bulkCancel', payload);
};

export const PermanentDelete = (id) => {
  return sllrHttp.delete(`/sllrSalesOrders/deleted/${id}`);
};

export const massPermanentDelete = (payload) => {
  return sllrHttp.delete('/sllrSalesOrders/deleted/bulk', payload);
};

export const exportDraftOrders = (payload) => {
  return bostaHttp.get('/draft-orders/export/orders', payload, downloadHeader);
};

export const getDraftOrderProducts = (id, params) => {
  return sllrHttp.get(`/sllrSalesOrders/${id}/items`, params);
};

export const deleteFlyersDraftOrder = (id) => {
  return bostaHttp.delete(`/draft-orders/${id}?creationSrc=FLYERS_DASHBOARD`);
};

export const getAvailableLocationByOrderId = (id, payload) => {
  return sllrHttp.post(`/sllrSalesOrders/${id}/available-locations`, payload);
};

export const exportOrders = (payload) => {
  return sllrHttp.get(`/salesOrders/export/v2/xlsx`, payload);
};

export const getValueProofUploadLink = () => {
  return bostaHttp.get(
    `/deliveries/signedAttachmentUrl?type=deliveryProofOfCost`
  );
};

export const getInsuranceFees = (payload) => {
  return bostaHttp.get(`pricing/insuranceFeeEstimate?`, payload);
};
